enum ViewState {
  SignIn,
  SetupPhoneNumber,
  VerifyMFA,
  MFASuccess
}

export default ViewState;
